import { useQuery, type UseQueryOptions } from '@tanstack/react-query'
import { getWorkerAssessment } from 'api/admin/coach/getWorkerAssessment'
import { coachKeys } from './keys'

type UseAssessmentDetailQueryData = Awaited<
  ReturnType<typeof getWorkerAssessment>
>
type UseAssessmentDetailQueryParams = Parameters<typeof getWorkerAssessment>[0]
type UseAssessmentDetailQueryKey = ReturnType<typeof coachKeys.assessmentDetail>

type UseAssessmentDetailQueryOptions = Partial<
  UseQueryOptions<
    UseAssessmentDetailQueryData,
    Error,
    UseAssessmentDetailQueryData,
    UseAssessmentDetailQueryKey
  >
>

export const useAssessmentDetail = (
  params: UseAssessmentDetailQueryParams,
  options: UseAssessmentDetailQueryOptions = {}
) => {
  const { positionId, userId } = params

  return useQuery<
    UseAssessmentDetailQueryData,
    Error,
    UseAssessmentDetailQueryData,
    UseAssessmentDetailQueryKey
  >({
    ...options,
    queryKey: coachKeys.assessmentDetail(positionId, userId),
    queryFn: () => getWorkerAssessment({ positionId, userId }),
  })
}
